"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueFormList = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const debounce_1 = __importDefault(require("debounce"));
const loading_indicator_1 = require("../../../loading-indicator");
const create_attribute_form_styles_1 = require("../create-attribute-form.styles");
const form_value_list_row_1 = require("../form-value-list-row");
const value_form_list_utils_1 = require("./value-form-list.utils");
const value_list_content_component_1 = require("./value-list-content.component");
const add_some_values_button_1 = require("../partials/add-some-values-button");
const client_constants_1 = require("../../../../client/client.constants");
const values_1 = require("../../../../client/values");
const hooks_1 = require("../../../../hooks");
const models_1 = require("../../../../models");
const utils_1 = require("../../../../utils");
const hooks_2 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const shouldSkipValueOptionsQuery = ({ isNewLabel, allowCreation, isReadOnly, hasRequestedValueOptions, }) => Boolean(isNewLabel || !allowCreation || isReadOnly || !hasRequestedValueOptions);
const ValueFormList = ({ attributeLabel, valueOptionListStrategyNodeId, selectedStrategyNodeId, values, name, hideDescription, isNewLabel, allowCreation, isReadOnly, matchedValueNames, loadedValueItems = [], valuesLoading = false, valuesHasNextPage = false, valuesMoreItemsLoading = false, sectionLabels, onValuesLoadMore, onBackendSearch, shouldConstrainListHeight = false, isHeaderSticky, onAddSome, onRemove, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const listRef = (0, react_1.useRef)(null);
    const previousEditableValueCountRef = (0, react_1.useRef)(0);
    const canLoadMoreValues = Boolean(onValuesLoadMore && valuesHasNextPage && !valuesLoading);
    const handleValuesLoadMore = (0, react_1.useCallback)(() => { var _a; return (_a = onValuesLoadMore === null || onValuesLoadMore === void 0 ? void 0 : onValuesLoadMore()) !== null && _a !== void 0 ? _a : Promise.resolve(); }, [onValuesLoadMore]);
    const lastElementRef = (0, hooks_1.useLoadMore)({
        moreItemsLoading: valuesMoreItemsLoading || valuesLoading,
        hasNextPage: canLoadMoreValues,
        onLoadMore: handleValuesLoadMore,
    });
    const [sizeMap, setSizeMap] = (0, react_1.useState)({});
    const [listContainerHeight, setListContainerHeight] = (0, react_1.useState)(0);
    const [lastMeasuredListContainerHeight, setLastMeasuredListContainerHeight] = (0, react_1.useState)(0);
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const [isSearchPending, setSearchPending] = (0, react_1.useState)(false);
    const [hasRequestedValueOptions, setHasRequestedValueOptions] = (0, react_1.useState)(false);
    const handleAddSomeValuesOpen = (0, react_1.useCallback)(() => {
        setHasRequestedValueOptions(true);
    }, []);
    const { data, pagination: { isLoadingMore, hasNextPage, onNextPage: fetchMore, }, isLoading: loading, searchText, refetch, } = (0, values_1.useGetStrategyValueOptionList)({
        catalogId: selectedCatalogId,
        productTreeNodeId: valueOptionListStrategyNodeId,
        attributeName: attributeLabel,
        excludeNodeIds: [selectedStrategyNodeId],
        sortingItem: models_1.SortingItem.SortByTextAsc,
        options: {
            skip: shouldSkipValueOptionsQuery({
                isNewLabel,
                allowCreation,
                isReadOnly,
                hasRequestedValueOptions,
            }),
            fetchPolicy: 'network-only',
        },
    });
    const [, filteredOptionList] = (0, react_1.useMemo)(() => {
        const existingValues = values.map(({ name }) => name);
        if (!data) {
            return [];
        }
        const existingItems = [];
        const allowedItems = [];
        const seen = new Set();
        data.forEach(({ node: { value, description } }) => {
            if (!value || seen.has(value)) {
                return;
            }
            seen.add(value);
            const item = { label: value, value, description: description !== null && description !== void 0 ? description : '' };
            if (existingValues.includes(value)) {
                existingItems.push(item);
            }
            else {
                allowedItems.push(item);
            }
        });
        return [existingItems, allowedItems];
    }, [values, data]);
    const handleSelect = (valueIds) => {
        if (!valueIds) {
            const list = filteredOptionList.map(({ value, description }) => ({ name: value, description: description !== null && description !== void 0 ? description : '' }));
            setTimeout(() => onAddSome(list), 0);
        }
        else {
            const newValues = filteredOptionList.filter(({ value }) => valueIds.includes(value));
            onAddSome(newValues.map(({ value, description }) => ({ name: value, description })));
        }
    };
    const handleCreate = (valueIds) => {
        onAddSome(valueIds.map((id) => ({ name: id, description: '' })));
    };
    const setSize = (0, react_1.useCallback)((index, size) => {
        var _a;
        setSizeMap((currentSizeMap) => {
            if (currentSizeMap[index] === size) {
                return currentSizeMap;
            }
            return Object.assign(Object.assign({}, currentSizeMap), { [index]: size });
        });
        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndex(index);
    }, []);
    (0, react_1.useEffect)(() => {
        const valuesToAdd = loadedValueItems.filter((loadedValue) => !values.some(({ name }) => ((0, utils_1.areEqualCaseInsensitive)(name, loadedValue.name))));
        if (valuesToAdd.length) {
            onAddSome(valuesToAdd);
        }
    }, [loadedValueItems, onAddSome, values]);
    const debouncedBackendSearch = (0, react_1.useMemo)(() => (0, debounce_1.default)((value) => {
        onBackendSearch === null || onBackendSearch === void 0 ? void 0 : onBackendSearch(value);
    }, client_constants_1.SEARCH_DELAY), [onBackendSearch]);
    (0, react_1.useEffect)(() => () => {
        debouncedBackendSearch.clear();
    }, [debouncedBackendSearch]);
    (0, react_1.useEffect)(() => {
        if (!valuesLoading) {
            setSearchPending(false);
        }
    }, [valuesLoading]);
    const handleSearchInputChange = (0, react_1.useCallback)((value) => {
        setSearchValue(value);
        if (onBackendSearch) {
            setSearchPending(true);
            debouncedBackendSearch(value);
        }
    }, [debouncedBackendSearch, onBackendSearch]);
    const filteredValueEntries = (0, react_1.useMemo)(() => ((0, value_form_list_utils_1.getFilteredValueEntries)(values, searchValue, matchedValueNames)), [matchedValueNames, searchValue, values]);
    const editableValueCount = (0, react_1.useMemo)(() => values.filter(({ readonly }) => !readonly).length, [values]);
    const displayValueEntries = (0, react_1.useMemo)(() => ((0, value_form_list_utils_1.getDisplayValueEntries)(filteredValueEntries, canLoadMoreValues, sectionLabels)), [canLoadMoreValues, filteredValueEntries, sectionLabels]);
    const displayValueEntriesKey = (0, react_1.useMemo)(() => ((0, value_form_list_utils_1.getDisplayValueEntriesKey)(displayValueEntries)), [displayValueEntries]);
    const getSize = (0, react_1.useCallback)((index) => ((0, value_form_list_utils_1.getValueListItemSize)(displayValueEntries, sizeMap, index)), [displayValueEntries, sizeMap]);
    const listHeight = (0, react_1.useMemo)(() => ((0, value_form_list_utils_1.getValueListHeight)(displayValueEntries, getSize)), [displayValueEntries, getSize]);
    const listWindowHeight = (0, react_1.useMemo)(() => (0, value_form_list_utils_1.getValueListWindowHeight)({
        shouldConstrainListHeight,
        listHeight,
        listContainerHeight,
        lastMeasuredListContainerHeight,
    }), [lastMeasuredListContainerHeight, listContainerHeight, listHeight, shouldConstrainListHeight]);
    const hasListOverflow = (0, value_form_list_utils_1.hasValueListOverflow)(shouldConstrainListHeight, listHeight, listWindowHeight);
    const handleListContainerResize = (0, react_1.useCallback)((element) => {
        const height = (0, value_form_list_utils_1.getListContainerHeight)(element);
        setListContainerHeight((currentHeight) => (currentHeight === height ? currentHeight : height));
        if (height > form_value_list_row_1.LIST_LOAD_MORE_HEIGHT) {
            setLastMeasuredListContainerHeight((currentHeight) => (currentHeight === height ? currentHeight : height));
        }
    }, []);
    const listContainerRef = (0, hooks_2.useResizeObserver)(handleListContainerResize);
    (0, react_1.useEffect)(() => {
        var _a;
        setSizeMap({});
        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndex(0);
    }, [displayValueEntriesKey]);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0);
    }, [searchValue]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (editableValueCount > previousEditableValueCountRef.current) {
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0);
        }
        previousEditableValueCountRef.current = editableValueCount;
    }, [editableValueCount]);
    const duplicateIndices = (0, react_1.useMemo)(() => {
        const seen = new Map();
        const dupes = new Set();
        values.forEach(({ name: n }, i) => {
            const key = n;
            if (seen.has(key)) {
                dupes.add(i);
                dupes.add(seen.get(key));
            }
            else {
                seen.set(key, i);
            }
        });
        return dupes;
    }, [values]);
    const itemData = (0, react_1.useMemo)(() => ({
        name,
        items: displayValueEntries,
        setSize,
        lastElementRef,
        descriptionFieldTitle: t({ key: 'ENTITY_GUIDELINES', values: { entity: t({ key: 'VALUE' }) } }),
        hideDescription,
        isReadOnly,
        onRemove,
        duplicateIndices,
    }), [displayValueEntries, hideDescription, isReadOnly, lastElementRef, name, onRemove, setSize, t]);
    if (!attributeLabel) {
        return null;
    }
    const isLoading = !data && loading;
    const hasRenderedValues = displayValueEntries.length > 0;
    const isValueSearchLoading = Boolean(onBackendSearch && (isSearchPending || (valuesLoading && !hasRenderedValues)));
    return (react_1.default.createElement(create_attribute_form_styles_1.StyledFormSection, null, react_1.default.createElement("div", { className: `form-section-header${isHeaderSticky ? ' form-section-header--sticky' : ''}` }, react_1.default.createElement("div", { className: "form-section-heading-content" }, react_1.default.createElement("div", { className: "form-section-subheading" }, t({ key: 'VALUES_FORM_SECTION_TITLE' })), isHeaderSticky && react_1.default.createElement("div", { className: "form-section-attribute-name" }, attributeLabel)), react_1.default.createElement(ui_components_1.SearchField, { className: "form-section-search", size: "small", placeholder: t({ key: 'SEARCH' }), value: searchValue, onChange: handleSearchInputChange }), allowCreation && !isReadOnly && (react_1.default.createElement(add_some_values_button_1.AddSomeValuesButton, { className: "action-add", options: filteredOptionList, isLoading: isLoading, moreItemsLoading: isLoadingMore,
        // TODO: networkStatus is wrong when refetching a lazy query (setVariables instead of refetch)
        isSearching: loading, searchText: searchText, hasNextPage: hasNextPage, onSelect: handleSelect, onCreate: handleCreate, onLoadMore: fetchMore, onSearch: refetch, onOpen: handleAddSomeValuesOpen }))), react_1.default.createElement(value_list_content_component_1.ValueListContent, { isValueSearchLoading: isValueSearchLoading, displayValueEntries: displayValueEntries, shouldConstrainListHeight: shouldConstrainListHeight, listContainerRef: listContainerRef, listHeight: listHeight, listWindowHeight: listWindowHeight, hasListOverflow: hasListOverflow, listRef: listRef, getSize: getSize, itemData: itemData }), valuesMoreItemsLoading && react_1.default.createElement(loading_indicator_1.LoadingIndicator, { className: "load-more-indicator" })));
};
exports.ValueFormList = ValueFormList;
exports.default = exports.ValueFormList;
